import Worktags from '@/shared/api/worktags';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

type UpdateShiftTemplateTagResponse = {};

export const updateShiftTemplateTag = createWiwAsyncThunk<UpdateShiftTemplateTagResponse, any>(
  'tags/shiftTemplates/update',
  async (tag, { rejectWithValue }) => {
    try {
      return (await Worktags.url(`/templates/${tag.id}`).put(tag.toJSON())) as UpdateShiftTemplateTagResponse;
    } catch (error) {
      return rejectWithValue(parseAPIError(error));
    }
  },
);
